import React, { FC, useState } from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import _ from "lodash";
import {
  ContactTracePanel,
  LogisticsPanel,
  Nine11Panel,
  RideDispatchPanel,
  RxPanel,
  StorePanel,
} from "..";


const RidePanel: FC<{
  type?: string;
  params: DashboardParams;
}> = ({ type, params }) => {
  switch (type) {
    case "RxPanel":
      return <RxPanel params={params} />;
    case "RideDispatch":
      return <RideDispatchPanel params={params} />;
    case "Store":
      return <StorePanel params={params} />;
    case "Nine11":
      return <Nine11Panel params={params} />;
    case "Logistics":
      return <LogisticsPanel params={params} />;
    case "ContactTracing":
      return <ContactTracePanel params={params} />;
    default:
      return <div></div>;
  }
};

export default RidePanel;
